import React from 'react'
import { List, Button, Card, Label } from 'semantic-ui-react'
import _ from 'lodash'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}

const OptionCard = ({ option, onEditClick }) => {
  const choices = _.map(option.choices, (choice, choiceId) => ({ ...choice, id: choiceId }))
  const sortedChoices = _.sortBy(choices, 'order')

  return (
    <Card>
      <Card.Content>
        <Card.Header>{option.name}</Card.Header>
        <Card.Description>
          <div>
            <Label size="small" color={option.is_required ? 'red' : 'green'}>
              {option.is_required ? 'Required' : 'Optional'}
            </Label>
            {
              option.is_multiple && (
                <Label size="small" color='orange'>
                  Maximum: {option.max_choice}
                </Label>
              )
            }
          </div>
          <div>
            <List divided verticalAlign='middle' style={{ marginTop: 10 }}>
              {_.map(sortedChoices, choice => (
                <List.Item key={choice.id}>
                  <List.Content style={styles.listContentWrapper}>
                    <div style={{ display: 'flex', flex: 1 }}>
                      {choice.name}
                    </div>
                    <div style={{ display: 'flex' }}>
                      {option.default_choice === choice.id &&
                        <Label size="small">
                          default
                        </Label>
                      }
                      <Label size="small">
                        $ {choice.price}
                      </Label>
                    </div>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          </div>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div>
          <Button color='black' size="tiny" fluid onClick={onEditClick}>
            Edit
          </Button>
        </div>
      </Card.Content>
    </Card>
  )
}

export default OptionCard


// WEBPACK FOOTER //
// ./src/components/restaurants/views/itemOptionCard.js